<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list @form="dialog = true" @clear="$refs.form.clear()" />
        <form-manager ref="form" :dialog="dialog" @close="dialog = false" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormManager from './FormManager'
import List from './List'

export default {
  name: 'Stadiums',
  components: {
    List,
    FormManager,
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.$store.dispatch('stadiums/resetState')
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
      stadiumId: (state) => state.stadiums.idSelected,
    }),
  },
  methods: {
    ...mapActions({
      fetchStadiums: 'stadiums/fetchList',
      fetchStadiumSelect: 'stadiums/fetchSelectList',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      // this.resetPagitations()
      await Promise.all([this.fetchStadiums({ limit: 0 })])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
    stadiumId(val) {
      if (val) this.fetchStadiumSelect({ _id: val })
    },
  },
}
</script>
